<template>
<div>
  <router-view />
    <div class="msg">
     <p> Select the products and also input details for inventory optimization, Please edit the column which is in block. Also, some are optional so you don't have to fill in all details</p>
      </div>
  <div class="q-pa-md">
    <q-table
      :loading="isLoading"
      ref="table"
      title="Inventory"
      :data="data"
      :columns="columns"
      row-key="id"
      :selected-rows-label="getSelectedString"
      selection="multiple"
      :selected.sync="selected"
      no-data-label="No Result Found"
    >
      <template v-slot:top-right>
        <q-input
          dense
          debounce="300"
          placeholder="Search"
          v-model="filter"
          @input="
            (val) => {
              searchHandler(val);
            }
          "
        >
          <q-icon slot="append" name="search" />
        </q-input>
      </template>

      <template v-slot:header="props">
        <q-tr :props="props">
          <q-th></q-th>
          <q-th
            v-for="col in columns"
            :key="col.name"
            :props="props"
            class="headerText"
          >
            {{ col.label }}
          </q-th>
        </q-tr>
      </template>
      <template v-slot:body="props">
        <q-tr :props="props">
          <q-td>
            <q-checkbox v-model="props.selected" />
          </q-td>

          <q-td key="id" :props="props">
            {{ props.row.id }}
          </q-td>

           <q-td key="name" :props="props">
            {{ props.row.name }}
          </q-td>

           <q-td key="shop" :props="props">
            {{ props.row.shop }}
          </q-td>
          
           
           <!-- <q-td key="count" :props="props">
            {{ props.row.count }}
          </q-td> -->
          <q-td class="den" key="countinput" :props="props" >
           {{ props.row.countinput?props.row.countinput:props.row.count}}
            <q-popup-edit v-model="props.row.countinput" title="Edit the count" auto-save>
              <q-input type="number" v-model.number="props.row.countinput" dense autofocus counter ></q-input>
            </q-popup-edit>
          </q-td>
           <!-- <q-td key="sellingprice" :props="props">
            {{ props.row.sellingprice}}
          </q-td> -->
          <q-td class="den" key="sellingpriceinput" :props="props">
            {{ props.row.sellingpriceinput?props.row.sellingpriceinput:props.row.sellingprice}}
            <q-popup-edit v-model="props.row.sellingpriceinput" title="Edit the sellingprice" auto-save>
              <q-input type="number" v-model.number="props.row.sellingpriceinput" dense autofocus counter ></q-input>
            </q-popup-edit>
          </q-td>
          <!-- <q-td key="costprice" :props="props">
            {{ props.row.costprice}}
          </q-td> -->
          <q-td class="den" key="editcostpriceinput" :props="props">
            {{ props.row.editcostpriceinput?props.row.editcostpriceinput:props.row.costprice}}
            <q-popup-edit v-model="props.row.editcostpriceinput" title="Edit the costprice" auto-save>
              <q-input type="number" v-model.number="props.row.editcostpriceinput" dense autofocus counter ></q-input>
            </q-popup-edit>
          </q-td>
           <q-td class="den" key="minimumorderqtyinput" :props="props">
             {{props.row.minimumorderqtyinput?props.row.minimumorderqtyinput:0}}
             <q-popup-edit v-model="props.row.leadtime" title="Enter the minimum reorderqty" auto-save>
              <q-input type="number" placeholder="please enter here" v-model.number="props.row.minimumorderqtyinput" dense autofocus ></q-input>
             </q-popup-edit>
          </q-td>
           <q-td class="den" key="leadtime" :props="props">
             {{props.row.leadtime?props.row.leadtime:0}}
            <q-popup-edit v-model="props.row.leadtime" title="Enter the leadtime" auto-save>
              <q-input type="number" placeholder="enter the leadtime" v-model.number="props.row.leadtime" dense autofocus counter ></q-input>
          </q-popup-edit>
          </q-td>
          <q-td class="den" key="scrapvalue" :props="props">
             {{props.row.scrapvalue?props.row.scrapvalue:0}}
            <q-popup-edit v-model="props.row.scrapvalue" title="Enter the scrapvalue" auto-save>
              <q-input type="number" placeholder="enter the scrapvalue" v-model.number="props.row.scrapvalue" dense autofocus counter ></q-input>
          </q-popup-edit>
          </q-td>
          <q-td key="model" :props="props">
             <!-- <div class="q-pa-md"> -->
    <q-btn-dropdown flat style="color: black" class="dropdown" :label="labelling(props.row.model)">
      <q-list>
        <q-item clickable v-close-popup @click ="props.row.model = 'ROP'">
          <q-item-section>
            <q-item-label  >Around the year business</q-item-label>
          </q-item-section>
        </q-item>

        <q-item clickable v-close-popup @click="props.row.model = 'EOQ'">
          <q-item-section>
            <q-item-label>Pershible Goods</q-item-label>
          </q-item-section>
        </q-item>

        <q-item clickable v-close-popup @click="props.row.model = 'Newsvendor'">
          <q-item-section>
            <q-item-label>Seasonal Goods</q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </q-btn-dropdown>
  <!-- </div> -->
            </q-td>

        </q-tr>
      </template>
    </q-table>
  </div>
  
     <div class="q-pa-md">
       <div class="txt">
    <p>please add the below constraints for inventory optimization(optional)</p>
     </div>
     <div>
       <div class="q-gutter-md inps" style="max-width: 300px">
     
       <p class="lette">Maximum budget for the month:</p>
       
     
          <q-input outlined v-model.number="maximumbudget" label="maximumbudget"></q-input>
         
      
    
        <p class="lette">How many months of advance forecast required :  </p>
   
      
        <q-input outlined v-model.number="forecastrequired" label="Required Months"></q-input>
     
     </div>
     </div>

    
      </div>
  <div class="priceOptButton">
      <button class="buttn" @click="optimise()">
        Add to Inventory Optimization
      </button>
    </div>
  </div>
</template>
<style>
.dropdown{
  width:3rem;
  height:2rem;
  background: transparent;
  font-size:9px;
  border:none 
}

.msg{
  margin-top:5%;
  text-align:center;
  color:red;
  font-size:15px;
}
.den{
  font-weight:bold;
  text-decoration:underline;
}
.lette{
  color:blue;
  font-size:15px;
  font-weight:bold;
}
.inps{
  align-content:center;
  text-align:center;
  margin-left:37%;
  margin-top:5%;
}
@media screen and (max-width: 1200px) {
  .inps{
  margin-left:30%;
  }
}
.txt{
  text-align:center;
  color:red;
  font-size:15px;
}
.float-child{
  float:left;
}
.errorClass {
  background: red;
}
.check {
  height: 1rem;
  margin-top: 1rem;
}
.priceOptButton {
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
  /* position: sticky; */
  bottom: 1rem;
}
.buttn {
  background: rgb(0, 88, 252);
  color: white;
  border-radius: 4px;
  border-color: white;
  height: 3rem;
  font-weight: 500;
}
.buttn:hover {
  cursor: pointer;
}
.headerText {
  color: blue;
  font-weight: 800;
}
.fit{
   border-top-left-radius: 0px !important;
   border-bottom-right-radius: 0px !important;
   border-bottom-left-radius: 0px !important;
   background: white!important;
box-shadow: 0px 3px 6px #00000030;


}
.q-checkbox__svg {
    color: blue!important;
}
</style>

<script>
export default {
  data() {
    return {
      api_url:  this.$store.state.API_URL[process.env.VUE_APP_ENV],
      isLoading: true,
      selectedRow: [],
      selected: [],
      countinput:[],
      sellingpriceinput:[],
      editcostpriceinput:[],
      minimumorderqtyinput:[],
      leadtime:[],
      model:[],
      scrapvalue:[],
      maximumbudget:0,
      forecastrequired:0,
      errorcarbs: false,
      errorClassData: [],
      errorMessagecarbs: "",
      submitVisibliliy: true,
      backupList: [],
      columns: [
        {
          name: "id",
          required: true,
          label: "ProductId",
          align: "left",
          sortable: true,
          field: "id",
          required: true,
        },
         {
          name: "name",
          align: "left",
          label: "ProductName",
          field: "name",
          sortable: true,
          headerStyle: "width: 200px",
        },
         {
          name: "shop",
          align: "left",
          label: "ShopName",
          field: "shop",
          sortable: true,
        },
       
        
       

        //  { name: "count", label: "Count",field:"count", align: "center" },
         { name: "countinput", label: "Count",field:"countinput", align: "center" },
        // { name: "sellingprice", label: "Selling Price",field:"sellingprice", align: "center" },
         { name: "sellingpriceinput", label: "Sellingprice",field:"sellingpriceinput", align: "center" },
            // { name: "costprice", label: "Cost Price",field:"costprice", align: "center" },
         { name: "editcostpriceinput", label: "Costprice",field:"costpriceinput", align: "center" },
          { name: "minimumorderqtyinput", label: "MinimumOrderQuantity",field:"minimumorderqtyinput", align: "center" },
           { name: "leadtime", label: "LeadTime",field:"leadtime", align: "center" },
           { name: "scrapvalue", label: "Scrap Value",field:"scrapvalue", align: "center" },
            {
          name: "model",
          align: "center",
          label: "Select Model",
          field: "model",
          sortable:true
          
        },
      ],
      //  columnss: [
      //   {
      //     name: "q_no",
      //     required: true,
      //     label: "Q.No",
      //     align: "center",
      //     field: "q_no",
      //   },
      //   {
      //     name: "question",
      //     align: "center",
      //     label: "Question",
      //     field: "question",
      //   },

      //   { name: "check_yes", label: "", align: "center",field:"check_yes", label:"Response" },
      // ],
      // data: [
      //   {
      //     q_no: 1,
      //     question: 'Are you satisfied with the predicted value',
          
      //   },
      //   {
      //     q_no: 2,
      //     question: 'Are you satisfied with the predicted value',
          
      //   },
      //   {
      //     q_no: 3,
      //     question : 'Are you satisfied with the predicted value',
          
      //   }
      // ],
     
      filter: "",
      data: [],
     
    };
  },
  created() {
    var productsURL = this.api_url + "/products/inventory_display";
    this.$http
      .get(productsURL)
      .then((response) => {
        let result = response.data;
        // console.log(result)

        let data = result.map((items) => {
          return {
            ...items,
          };
        });
        console.log(data)
        
        this.data = data;
        
        this.backupList = data;
        this.isLoading = false;
      })
      .catch((err) => {
            this.$q.notify({
            message: err,
            color: "negative",
          });
            this.isLoading = false;
        //console.log(err);
      });
  },
  computed:{
    //  dropdownlabel(nam){
    //   if(nam==='Newsvendor')
    //   {
    //     return "seasonalgoods";
    //   }else if(nam==='EOQ')
    //   {
    //     return "perishablegoods";
    //   }else{
    //     return "aroundtheyearbusiness";
    //   }

    // },
  },
  // mounted() {
  //   setTimeout(() => {
  //     let data = this.exampleData.map((items) => {
  //       return {
  //         ...items,
  //         input: items.priceCost ? items.priceCost : 0 ,
  //       };
  //     });
  //     this.data = data;
  //     this.backupList = data;
  //     this.isLoading = false;
  //   }, 1000);
  // },
  mounted(){
    this.$q.loading.show({
       message: "Authenticating please wait..",
     });


      if(this.$cookies.isKey("login_authentication"))
     {
       let encryptedText = this.$cookies.get("login_authentication");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
         this.$store.dispatch("setPathName", "/inventoryoptimization/inventory");
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
       }
       
     }
     else  if(this.$cookies.isKey("login_authentication1"))
     {
       let encryptedText = this.$cookies.get("login_authentication1");

       const decryptedText = this.$CryptoJS.AES.decrypt(encryptedText, process.env.VUE_APP_ENCRYPTION_SECRET_KEY).toString(this.CryptoJS.enc.Utf8);

       console.log("decrypt: ",decryptedText);
       if(decryptedText == "authenticated")
       {
         this.$q.loading.hide();
         this.$store.dispatch("setPathName", "/inventoryoptimization/inventory");
        this.isAuthenticated = true;

       }
       else{
          this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
       }
       
     }
     else{
       this.$q.loading.hide();
          this.$router.push({
            name: "NotAuthenticated",
          });
          return;
     }
  },
  
  methods: {
     searchHandler(value) {
      if (value.length >= 3) {
        let searchResult = this.backupList.filter((item) => {
          return item.title.toLowerCase().includes(value.toLowerCase());
        });
        this.data = searchResult;
      } else {
        this.data = this.backupList;
      }
    },
       labelling(nam){
      if(nam==='Newsvendor')
      {
        return "seasonalgoods";
      }else if(nam==='EOQ')
      {
        return "perishablegoods";
      }else{
        return "aroundtheyearbusiness";
      }

    },
    // searchHandler(value) {
    //   if (value.length >= 3) {
    //     let searchResult = this.backupList.filter((item) => {
    //       return item.title.toLowerCase().includes(value.toLowerCase());
    //     });
    //     this.data = searchResult;
    //   } else {
    //     this.data = this.backupList;
    //   }
    // },
    // onItemClick () {
    //     // console.log('Clicked on an Item')
    //     this.model = 'aroundtheyearbusiness'

    //   },
    // onItemClickk () {
    //     // console.log('Clicked on an Item')
    //     this.model = 'perishablegoods'

    //   },
    //   onItemClickkk () {
    //     // console.log('Clicked on an Item')
    //     this.model = 'seasonalgoods'

    //   },
      
    optimiseApiCall(selectedProductList) {
      const product =  selectedProductList.map((product) => (
      {
        "id":product.id,
        "name":product.name,
        "shop":product.shop,
        "count":product.countinput?product.countinput:(product.count?product.count:0),
        "sellingprice":product.sellingpriceinput?product.sellingpriceinput:(product.sellingprice?product.sellingprice:0),
        "costprice":product.editcostpriceinput?product.editcostpriceinput:(product.costprice?product.costprice:0),
        "minimumorderquantity":product.mimimumorderquantity?product.mimimumorderquantity:0,
        "leadtime":product.leadtime?product.leadtime:0,
        "scrapvalue":product.scrapvalue?product.scrapvalue:0,
        "model":product.model?product.model:"ROP"
              
      }
      ));
      // const type = this.$route.query.type;
      const maximumbudget = this.maximumbudget?this.maximumbudget:0;
      const forecastrequired = this.forecastrequired?this.forecastrequired:0;
      return [{"maximumbudget":maximumbudget,"forecastrequired":forecastrequired, "shop":product}]
    },

    optimise() {
      if (this.selected.length === 0) {
        this.$q.notify({
          message: "Please select atleast one product",
         color: 'grey-3',
  textColor: 'blue',
        });
        // console.log("Please select atleast one product");
      } else {
        if (this.errorClassData == 0) {
          this.$q.notify({
            message: "Processing",
            color: 'grey-3',
  textColor: 'blue',
          });
          // console.log("Calling API");
          // window.location.href = "/";
          let postURL = this.api_url + `/products/trigger_inventory_optimization`;
          this.$http.post(postURL, this.optimiseApiCall(this.selected)).then((response) => {
            if(response.data){
              console.log(response.data)
               this.$q.notify({
            message: 'Added to optimization',
             color: 'grey-3',
  textColor: 'blue',
          });
// setTimeout(() => {
//  this.$router.push({path: '/recommendations'});
// }, 1000);

setTimeout(() => {
  window.location.href='/inventoryoptimization/inventoryresult/:id'
}, 1000);

          // calling other route with unique id
         // console.log(response.data);
            }else{
                this.$q.notify({
            message: 'Error Occured!',
            color: 'grey-5',
  textColor: 'negative',
          });
            }
          }).catch(e =>{
             this.$q.notify({
            message: e.message,
            color: 'grey-5',
  textColor: 'negative',
          });
          });
         } 
         //else {
  //         this.errorClassData = [];
  //         this.$q.notify({
  //           message: "please check selected Input (minimun cost)",
  //           color: 'grey-5',
  // textColor: 'negative',
  //         });

  //         console.error("please check selected Input (minimun cost)");
  //       }
      }
    },

  },
};
</script>
